import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    delay: { type: Number, default: 500 }
  }

  disconnect() {
    this.clearTimer()
  }

  submit() {
    this.clearTimer()
    this.element.requestSubmit()
  }

  debouncedSubmit() {
    this.clearTimer()
    this.timer = setTimeout(() => {
      this.submit()
    }, this.delayValue)
  }

  clearTimer() {
    if (!this.timer) return

    clearTimeout(this.timer)
    this.timer = null
  }
}
